import { useNavigate } from 'react-router-dom';

import { constructRoute } from './routeUtils';

export const useNavigateTo = () => {
  const navigate = useNavigate();

  return (route: string, props?: string, state?: any, newTab: boolean = false) => {
    if (newTab) {
      window.open(constructRoute(route, props), '_blank');
    } else {
      navigate(constructRoute(route, props), { state });
    }
  };
};
